import { Divider, Grid, Typography } from '@mui/material';
import { MuiButton, MuiStack } from '../../../../components';
import { useAppSelector } from '../../../../store/hooks';
import { systemColor } from '../../../../theme/systemColor';
import { PurchaseRequisitionKeys } from '../services/entity';
var PartInfoTooltip = function () {
    var _crud$PurchaseRequisi, _crud$PurchaseRequisi2, _crud$PurchaseRequisi3, _data$ProductName, _data$SegmentTypeName, _data$PurchaseBasePri, _data$PurchaseBasePri2, _data$AvailableQuanti, _data$BrandName, _data$ManufacturerNam, _data$SegmentTypeName2, _data$HsnCode;
    var crud = useAppSelector(function (state) { return state.crud; });
    var data = (_crud$PurchaseRequisi = (_crud$PurchaseRequisi2 = crud[PurchaseRequisitionKeys.PartDetailsByProductId]) === null || _crud$PurchaseRequisi2 === void 0 ? void 0 : _crud$PurchaseRequisi2.data) !== null && _crud$PurchaseRequisi !== void 0 ? _crud$PurchaseRequisi : (_crud$PurchaseRequisi3 = crud[PurchaseRequisitionKeys.Get]) === null || _crud$PurchaseRequisi3 === void 0 || (_crud$PurchaseRequisi3 = _crud$PurchaseRequisi3.data) === null || _crud$PurchaseRequisi3 === void 0 ? void 0 : _crud$PurchaseRequisi3.PurchaseProcurementDetails[0];
    return /*#__PURE__*/ React.createElement(Grid, {
        padding: 0,
        width: "370px"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 2,
        justifyContent: 'space-between',
        flexDirection: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 400
        }
    }, (_data$ProductName = data === null || data === void 0 ? void 0 : data.ProductName) !== null && _data$ProductName !== void 0 ? _data$ProductName : "-"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: "textSecondary",
        sx: {
            color: systemColor.secondary,
            fontSize: '18px',
            fontWeight: 500
        }
    }, (_data$SegmentTypeName = data === null || data === void 0 ? void 0 : data.SegmentTypeName) !== null && _data$SegmentTypeName !== void 0 ? _data$SegmentTypeName : "-")), /*#__PURE__*/ React.createElement(Grid, {
        padding: 2,
        gap: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        alignItems: "center",
        sx: {
            marginBottom: '10px'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 8
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 500
        }
    }, "Rate (\u20B9)"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        sx: {
            color: systemColor.secondary,
            fontSize: '18px',
            fontWeight: 500
        }
    }, "\u20B9 ", (_data$PurchaseBasePri = data === null || data === void 0 || (_data$PurchaseBasePri2 = data.PurchaseBasePrice) === null || _data$PurchaseBasePri2 === void 0 ? void 0 : _data$PurchaseBasePri2.Price) !== null && _data$PurchaseBasePri !== void 0 ? _data$PurchaseBasePri : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        sx: {
            textAlign: 'left',
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 500
        }
    }, "Available Qty"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: systemColor.secondary,
            fontSize: '14px',
            fontWeight: 400
        }
    }, (_data$AvailableQuanti = data.AvailableQuantity) !== null && _data$AvailableQuanti !== void 0 ? _data$AvailableQuanti : "-"))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        sx: {
            marginTop: '10px'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 500
        }
    }, "Brand:"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: systemColor.secondary,
            fontSize: '14px',
            fontWeight: 400
        }
    }, " ", (_data$BrandName = data === null || data === void 0 ? void 0 : data.BrandName) !== null && _data$BrandName !== void 0 ? _data$BrandName : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 500
        }
    }, "Manufacturer:"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: systemColor.secondary,
            fontSize: '14px',
            fontWeight: 400
        }
    }, " ", (_data$ManufacturerNam = data === null || data === void 0 ? void 0 : data.ManufacturerName) !== null && _data$ManufacturerNam !== void 0 ? _data$ManufacturerNam : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 500
        }
    }, "Segment type:"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: systemColor.secondary,
            fontSize: '14px',
            fontWeight: 400
        }
    }, " ", (_data$SegmentTypeName2 = data === null || data === void 0 ? void 0 : data.SegmentTypeName) !== null && _data$SegmentTypeName2 !== void 0 ? _data$SegmentTypeName2 : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        sx: {
            color: systemColor.lightGrey,
            fontSize: '12px',
            fontWeight: 500
        }
    }, "HSN Code:"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: systemColor.secondary,
            fontSize: '14px',
            fontWeight: 400
        }
    }, " ", (_data$HsnCode = data === null || data === void 0 ? void 0 : data.HsnCode) !== null && _data$HsnCode !== void 0 ? _data$HsnCode : "-"))), "HsnCode SegmentTypeName ManufacturerName BrandName AvailableQuantity Price ProductName"), /*#__PURE__*/ React.createElement(Grid, {
        textAlign: "right",
        paddingX: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        disabled: true,
        variant: "text",
        name: "View more",
        sx: {
            color: systemColor.primary,
            fontSize: '14px',
            fontWeight: 500
        }
    })));
};
export default PartInfoTooltip;
